import type { de } from "./de.ts";

export const it: typeof de = {
  app: { name: "divespots.ch", srTitle: "divespots.ch: siti d’immersione in Svizzera" },
  common: { close: "Chiudi", loading: "Caricamento …", retry: "Riprova" },
  diver: {
    title: "Account",
    nav: "Navigazione dell’account",
    nav_account: "Il mio account",
    nav_suggestions: "I miei suggerimenti",
    signIn: "Accedi",
    signOut: "Esci",
    menu: "Account di {{name}}",
    signOutFailed: "Uscita non riuscita. Riprova.",
    staffDirectTitle: "Modifica diretta",
    signOutOffline: "Per uscire serve una connessione.",
    staffDirect: "Come moderatore modifichi direttamente.",
    staffDirectLink: "All'area di amministrazione",
    needsConnection: "Questa pagina richiede una connessione.",
    login: {
      title: "Accedi",
      lead: "Ti mandiamo un link via e-mail. Vanno bene anche una passkey o una password.",
      registerTitle: "Crea un account",
      registerLead:
        "Inserisci il tuo indirizzo e-mail. Ti mandiamo un link che crea il tuo account.",
      registerSend: "Crea l’account",
      toRegister: "Non hai ancora un account? Registrati",
      toSignIn: "Hai già un account? Accedi",
      email: "E-mail",
      name: "Nome visualizzato",
      nameHint: "Solo per un nuovo account, ad esempio il tuo nome. Potrai cambiarlo dopo.",
      send: "Invia il link per e-mail",
      passkey: "Accedi con una passkey",
      sentTitle: "Controlla la tua posta",
      sentText:
        "Abbiamo inviato un link a {{email}}. È valido 5 minuti. Aprilo su questo dispositivo.",
      devHint: "Sviluppo: il link è stampato nella console dell’API.",
      otherEmail: "Usa un altro indirizzo",
      badEmail: "Inserisci un indirizzo e-mail valido.",
      banned: "Account sospeso.",
      password: "Accedi con una password",
      passwordLabel: "Password",
      passwordSubmit: "Accedi",
      wrongCredentials: "E-mail o password errati",
      passwordMissing: "Inserisci e-mail e password.",
      registrationClosed:
        "Le nuove registrazioni sono attualmente chiuse. Gli account esistenti possono continuare ad accedere.",
      rateLimited: "Troppi tentativi. Attendi un momento.",
      network: "Nessuna connessione. Riprova.",
      failed: "Non ha funzionato. Il link potrebbe essere scaduto o non valido.",
    },
    account: {
      title: "Il mio account",
      profile: "Profilo",
      name: "Nome visualizzato",
      nameHint: "Mostrato con i tuoi suggerimenti.",
      nameInvalid: "Inserisci da 1 a 120 caratteri.",
      passkeys: "Passkey",
      passkeyLead:
        "Con una passkey accedi senza link, con impronta, volto o codice del dispositivo.",
      passkeySetup: "Configura una passkey",
      passkeyNone: "Ancora nessuna passkey.",
      passkeyUnnamed: "Passkey",
      passkeyRemove: "Rimuovi la passkey {{name}}",
      passkeyAdded: "Passkey configurata.",
      passkeyFailed: "Non è stato possibile configurare la passkey.",
      passkeyUnsupported: "Questo dispositivo o browser non supporta le passkey.",
      offerTitle: "Configurare una passkey?",
      offerText: "La prossima volta accedi direttamente con quella, senza e-mail.",
      later: "Più tardi",
      session: "Sessione",
      dangerTitle: "Elimina l’account",
      dangerText:
        "Il tuo account e i dati di accesso vengono eliminati. I tuoi suggerimenti e le segnalazioni restano in forma anonima.",
      delete: "Elimina l’account",
      deleteTitle: "Eliminare davvero il tuo account?",
      deleteBody:
        "Non si può annullare. I tuoi suggerimenti restano sotto «Account eliminato», quelli in attesa vengono ritirati. Le tue segnalazioni restano anonime.",
      deleteConfirm: "Elimina definitivamente",
      deleteStaff:
        "Gli account del team non possono eliminarsi da soli. Un admin deve prima retrocederti.",
    },
    suggestions: {
      title: "I miei suggerimenti",
      empty:
        "Non hai ancora suggerito nulla. Apri un sito d’immersione e tocca «Suggerisci una modifica», oppure suggerisci un nuovo sito.",
    },
  },
  suggest: {
    lead: "Il tuo suggerimento viene controllato dal team prima di diventare visibile.",
    editLead:
      "Correggi ciò che non va. Vengono proposti solo i campi modificati. Il team li controlla prima che diventino visibili.",
    spotButton: "Suggerisci un sito d’immersione",
    spotTitle: "Suggerisci un nuovo sito d’immersione",
    editSpotButton: "Suggerisci una modifica",
    editSpotTitle: "Suggerisci una modifica: {{name}}",
    objectButton: "Suggerisci un oggetto",
    objectTitle: "Suggerisci un oggetto: {{name}}",
    objectHere: "Suggerisci un oggetto qui",
    editObjectButton: "Suggerisci una modifica all’oggetto",
    editObjectTitle: "Suggerisci una modifica all’oggetto: {{name}}",
    loginHint: "Accedi per segnalare avvistamenti o fare suggerimenti",
    noteTitle: "Nota per il team",
    note: "Nota",
    noteHint: "Facoltativo: come lo sai?",
    noteHintEdit: "Obbligatorio: cosa hai cambiato e perché?",
    send: "Invia il suggerimento",
    thanks: "Grazie! Il tuo suggerimento attende il controllo.",
    err: {
      tooMany:
        "Troppi suggerimenti aperti. Attendi che il team ne abbia controllati alcuni, oppure ritirane qualcuno.",
      gone: "Non esiste più o non è pubblico.",
      noteRequired: "Inserisci una nota.",
      nothingChanged: "Non hai ancora modificato nulla.",
    },
    status: {
      pending: "In verifica",
      approved: "Accettato",
      rejected: "Rifiutato",
      withdrawn: "Ritirato",
    },
    kind: {
      spot_create: "Nuovo sito d’immersione",
      object_create: "Nuovo oggetto",
      spot_edit: "Modifica di un sito",
      object_edit: "Modifica di un oggetto",
    },
    reason: "Motivo",
    withdraw: "Ritira",
    withdrawNamed: "Ritira il suggerimento «{{name}}»",
    withdrawTitle: "Ritirare questo suggerimento?",
    withdrawBody: "Il team non lo vedrà più.",
    more: "Carica altri",
    openSpot: "Apri il sito",
    openObject: "Apri il sito con l’oggetto",
  },
  review: {
    title: "Suggerimenti",
    filterStatus: "Stato",
    filterKind: "Tipo",
    filterSubmitter: "Inviato da",
    empty: "Nessun suggerimento.",
    back: "Torna all’elenco",
    pendingCount_one: "{{count}} suggerimento aperto",
    pendingCount_other: "{{count}} suggerimenti aperti",
    stale:
      "Superato: il bersaglio è cambiato dopo il suggerimento. Controlla bene il confronto prima di accettare.",
    targetGone: "Il bersaglio di questa modifica non esiste più.",
    diff: "Confronto",
    field: "Campo",
    before: "Attuale",
    after: "Suggerimento",
    value: "Valore",
    empty_value: "vuoto",
    approveTitle: "Accetta",
    publish: "Pubblica subito (altrimenti come bozza)",
    reason: "Motivo",
    reasonHint: "Facoltativo. Il subacqueo lo vede.",
    adjust: "Modifica prima di accettare",
    force: "Accetta comunque, anche se superato",
    approve: "Accetta",
    rejectTitle: "Rifiuta",
    rejectHint: "Obbligatorio. Il subacqueo vede il motivo.",
    reject: "Rifiuta",
    outcome: "Esito",
    adjustedNote: "Modificato dal team prima dell’accettazione.",
    err: {
      conflict: "Nel frattempo è cambiato (superato o già gestito). Ricarica la pagina.",
      badPayload: "Il suggerimento modificato non è valido.",
      reasonRequired: "Inserisci un motivo.",
    },
    keys: {
      name: "Nome",
      location: "Punto d’ingresso",
      parkingLocation: "Parcheggio",
      waterBody: "Specchio d’acqua",
      locality: "Località",
      difficulty: "Difficoltà",
      maxDepthM: "Profondità massima (m)",
      closedPeriods: "Periodi di chiusura",
      ratings: "Valutazioni",
      description: "Descrizione",
      access: "Accesso",
      parking: "Parcheggio (testo)",
      entry: "Ingresso (testo)",
      hazards: "Pericoli",
      restrictions: "Restrizioni",
      facilities: "Infrastruttura",
      type: "Tipo",
      depthOverrideM: "Profondità misurata",
      spotId: "Sito d’immersione",
    },
  },
  sighting: {
    none: "Ancora nessuna segnalazione",
    lastSeen: "Visto l’ultima volta: {{date}}",
    lastMissing: "Ultima segnalazione di assenza: {{date}}",
    count_one: "{{count}} segnalazione",
    count_other: "{{count}} segnalazioni",
    seenToday: "Visto oggi",
    seenOn: "Visto il {{date}}",
    gone: "Non c’è più",
    seenNamed: "{{name}}: segnala visto oggi",
    goneNamed: "{{name}}: segnala non c’è più",
    otherDay: "Un altro giorno (facoltativo)",
    history: "Cronologia",
    statusSeen: "visto",
    statusGone: "assente",
    thanks: "Grazie per la tua segnalazione!",
    badDate: "La data non è valida (non nel futuro, al massimo 2 anni indietro).",
    tooMany: "Troppe segnalazioni. Attendi un momento.",
  },
  offline: {
    badge: "Offline",
    save: "Salva offline",
    saved: "Salvato offline",
    estimate: "Mappe, fondale 3D e foto aerea: circa {{size}}.",
    confirm: "Salva",
    cancel: "Annulla",
    saving: "Salvataggio … {{percent}} %",
    progress: "Avanzamento del salvataggio",
    remove: "Rimuovi",
    removeNamed: "Rimuovi {{name}} dalla memoria offline",
    listTitle: "Salvati offline",
    empty: "Ancora nulla di salvato. Apri un sito d’immersione e tocca «Salva offline».",
    open: "Apri",
    total_one: "{{count}} sito d’immersione · {{size}}",
    total_other: "{{count}} siti d’immersione · {{size}}",
    unavailable: "Non disponibile offline",
    unavailableText:
      "Questo sito d’immersione non è stato salvato. Con una connessione puoi salvarlo per l’uso offline.",
    adminNeedsConnection: "L’amministrazione richiede una connessione",
    error: {
      quota: "Spazio insufficiente su questo dispositivo. Rimuovi dei siti salvati e riprova.",
      network: "Nessuna connessione. Salvataggio annullato.",
      failed: "Salvataggio non riuscito. Riprova.",
    },
  },
  pwa: { updateAvailable: "Nuova versione disponibile", reload: "Ricarica" },
  minimap: {
    title: "Mappa del lago",
    hide: "Nascondi la mappa del lago",
    show: "Mostra la mappa del lago",
    openSpot: "Vai al sito {{name}}",
    object: "Oggetto {{name}}",
    currentSpot: "{{name}}: sito attuale",
  },
  diveAccess: {
    chunkFailed: "Impossibile caricare la modalità immersione.",
    reload: "Ricarica",
    loadFailed: "Impossibile caricare. Riprova.",
    button: "Modalità immersione (beta)",
    unavailableTitle: "Non disponibile",
    unavailable: "Questa pagina non è disponibile.",
    back: "Torna alla mappa",
  },
  course: {
    same: "Stesso oggetto",
    title: "Rotta",
    from: "Rotta da {{name}}",
    to: "verso",
    pick: "Scegli la destinazione.",
    pickPin: "Oppure tocca un segnaposto.",
    noOthers: "Nessun altro oggetto.",
    fromHere: "Rotta da qui …",
    action: "Rotta",
    rowFrom: "Calcola la rotta da {{name}}",
    rowTo: "Rotta da {{from}} a {{name}}",
    asDestination: "Come destinazione",
    swap: "Scambia partenza e destinazione",
    close: "Chiudi la rotta",
    computing: "Calcolo …",
    unavailable: "Rotta non disponibile",
    compass: "Bussola",
    true: "geografico {{deg}}°",
    declination: "declinazione {{value}}",
    distance: "Distanza",
    depth: "Profondità",
    depthUnknown: "Profondità sconosciuta",
    slope: "Obliqua",
    back: "Ritorno",
    east: "E",
    west: "O",
    footnote:
      "Aiuto all'orientamento dalle posizioni registrate (± alcuni metri). Non sostituisce la pianificazione dell'immersione.",
  },
  menu: {
    open: "Menu",
    title: "Menu",
    close: "Chiudi il menu",
  },
  language: { label: "Lingua", de: "Deutsch", en: "English", fr: "Français", it: "Italiano" },
  search: {
    label: "Cerca un sito d’immersione o un lago",
    placeholder: "Cerca un sito o un lago",
    clear: "Cancella la ricerca",
    noResults: "Nessun sito d’immersione trovato",
    results_one: "{{count}} risultato",
    results_other: "{{count}} risultati",
  },
  lakeFilter: { label: "Filtra per lago", all: "Tutti i laghi" },
  map: {
    controls: "Controlli della mappa",
    label: "Mappa dei siti d’immersione",
    layerLabel: "Livello della mappa",
    layerMap: "Mappa",
    layerAerial: "Foto aerea",
    zoomIn: "Ingrandisci",
    zoomOut: "Riduci",
    locate: "La mia posizione",
    locateDenied: "Accesso alla posizione negato. Consentilo nelle impostazioni del browser.",
    locateUnavailable: "Posizione non disponibile.",
    locateOutside: "La tua posizione è fuori dalla mappa.",
    spotPin: "Sito d’immersione {{name}}",
    spotPinClosed: "Sito d’immersione {{name}}, chiuso",
    spotPinPermanent: "Sito d’immersione {{name}}, chiuso definitivamente",
    cluster: "{{count}} siti d’immersione, tocca per ingrandire",
    loadError: "Non è stato possibile caricare i siti d’immersione.",
    attribution: "© swisstopo",
    scale: "Scala: {{distance}}",
  },
  wind: {
    toggle: "Vento",
    info: "Informazioni sulla previsione del vento",
    offline: "Il vento richiede una connessione internet",
    label: "Previsione del vento",
    time: "Ora della previsione",
    now: "Adesso",
    model: "Previsione del modello, livello del lago",
    run: "Run del modello {{time}}",
    placeCenter: "Centro della mappa",
    readout: "{{place}}: {{kmh}} km/h da {{dir}}",
    readoutNone: "{{place}}: nessun dato",
    readoutCalm: "{{place}}: calma",
    dir: { n: "N", ne: "NE", e: "E", se: "SE", s: "S", sw: "SO", w: "O", nw: "NO" },
    creditShort: "Vento:",
    creditMeteo: "MeteoSwiss via",
    chip: "Modello",
    creditVia: "Vento: MeteoSwiss ICON-CH via",
    interpolated: "interpolato",
    legend: "Velocità del vento in km/h",
    loading: "Caricamento del vento …",
    unavailable: "Il vento non è temporaneamente disponibile.",
  },
  precip: {
    toggle: "Precipitazioni (pioggia e neve)",
    info: "Informazioni sulla previsione delle precipitazioni",
    offline: "Le precipitazioni richiedono una connessione internet",
    infoBoth: "Informazioni sulla previsione di vento e precipitazioni",
    label: "Previsione delle precipitazioni",
    labelBoth: "Previsione di vento e precipitazioni",
    legend: "Pioggia e neve",
    class0: "debole",
    class1: "moderata",
    class2: "forte",
    class3: "molto forte",
    hours: "{{from}}–{{to}}",
    readout: "{{place}}: Precipitazioni: {{hours}} {{mm}} mm/h",
    readoutDry: "{{place}}: {{hours}} nessuna precipitazione",
    readoutNone: "{{place}}: Precipitazioni: nessun dato",
    model: "Modello, non radar",
    creditShort: "Precipitazioni:",
    creditBoth: "Vento/Precipitazioni:",
    creditVia: "Precipitazioni: MeteoSwiss ICON-CH via",
    creditViaBoth: "Vento/Precipitazioni: MeteoSwiss ICON-CH via",
    loading: "Caricamento delle precipitazioni …",
    unavailable: "Le precipitazioni non sono temporaneamente disponibili.",
  },
  sheet: {
    expandPanel: "Espandi la barra laterale",
    collapsePanel: "Comprimi la barra laterale",
    grabber: "Cambia l’altezza del pannello",
    detentPeek: "Piccolo",
    detentMedium: "Medio",
    detentLarge: "Grande",
    notFoundTitle: "Sito d’immersione non trovato",
    notFoundText: "Questo sito d’immersione non esiste o non è pubblico.",
    backToMap: "Torna alla mappa",
    loadError: "Non è stato possibile caricare il sito d’immersione.",
  },
  spot: {
    place: "{{locality}} · {{waterBody}}",
    view: "Vista",
    view2d: "2D",
    view3d: "3D",
    noBathy: "Nessun dato sul fondale",
    closedNowUntil: "Chiuso fino al {{date}}",
    closedNowReason: "Chiuso: {{reason}} fino al {{date}}",
    closedForGood: "Chiuso definitivamente",
    closedForGoodSince: "Chiuso definitivamente dal {{date}}",
    closedForGoodReason: "Motivo: {{reason}}",
    maxDepthBadge: "Max. {{value}}",
    objectCount_one: "{{count}} oggetto",
    objectCount_other: "{{count}} oggetti",
  },
  difficulty: {
    very_easy: "Molto facile",
    easy: "Facile",
    medium: "Medio",
    hard: "Difficile",
    very_hard: "Molto difficile",
  },
  facts: {
    title: "Dati",
    difficulty: "Difficoltà",
    maxDepth: "Profondità max.",
    waterBody: "Specchio d’acqua",
    locality: "Località",
    waterLevel: "Livello del lago",
    waterLevelValue: "{{value}} s.l.m.",
    entry: "Ingresso in acqua",
    parking: "Parcheggio",
  },
  objects: {
    title: "Oggetti",
    unnamed: "Oggetto senza nome",
    outside: "fuori dall’area — aumenta il raggio",
    noData: "Nessun dato",
    approx: "circa",
    provenance: "≈ calcolato dal modello del fondale swissBATHY3D, ±0.5 m",
    type: {
      figure: "Statua",
      toilet: "Gabinetto",
      wreck: "Relitto",
      vehicle: "Veicolo",
      platform: "Piattaforma",
      plaque: "Targa commemorativa",
      other: "Oggetto",
    },
  },
  sections: {
    description: "Descrizione",
    access: "Come arrivare",
    parking: "Parcheggi",
    entry: "Ingresso in acqua",
    hazards: "Pericoli",
    restrictions: "Restrizioni",
    facilities: "Servizi",
  },
  admin: {
    brand: "Admin",
    menu: "Area admin",
    nav: "Navigazione admin",
    nav_spots: "Siti d’immersione",
    nav_lakes: "Laghi",
    nav_users: "Utenti",
    nav_settings: "Impostazioni",
    nav_audit: "Registro",
    nav_suggestions: "Suggerimenti",
    toMap: "Alla mappa",
    edit: "Modifica",
    signOut: "Esci",
    signedInAs: "Accesso come {{name}}, {{role}}",
    common: {
      save: "Salva",
      saved: "Salvato.",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
    },
    role: { admin: "Admin", moderator: "Moderatore", diver: "Subacqueo" },
    status: {
      all: "Tutti",
      draft: "Bozza",
      published: "Pubblicato",
      pending: "In attesa",
    },
    login: {
      title: "Accedi",
      lead: "Solo per moderatori e admin. Gli account li crea un admin.",
      email: "E-mail",
      password: "Password",
      submit: "Accedi",
      missing: "Inserisci e-mail e password.",
      invalid: "E-mail o password errata.",
      banned: "Questo account è bloccato.",
      rateLimited: "Troppi tentativi. Riprova più tardi.",
      failed: "Accesso non riuscito. Riprova.",
      fixtures: "L’accesso richiede la vera API (non la modalità fixtures).",
    },
    forbidden: {
      staffOnly: "Quest’area è riservata al team.",
      title: "Accesso negato",
      body: "Questa pagina è riservata agli admin.",
      back: "Ai siti d’immersione",
    },
    discard: {
      title: "Annullare le modifiche?",
      body: "Le modifiche non sono state salvate e andranno perse.",
      confirm: "Annulla modifiche",
      keep: "Continua a modificare",
    },
    err: {
      concurrent: "Nel frattempo modificato da qualcun altro — valori aggiornati.",
      load: "Non è stato possibile caricare i dati.",
      save: "Non ha funzionato. Riprova.",
      fix: "Correggi i campi evidenziati.",
      auth: "La sessione è scaduta o mancano i permessi. Accedi di nuovo.",
      required: "Campo obbligatorio.",
      invalid: "Valore non valido.",
      slug: "Solo minuscole, cifre e trattini singoli.",
      slugTaken: "Questo slug è già in uso.",
      coords: "Inserisci una coordinata valida (gradi decimali).",
      mmdd: "Formato MM-GG, per esempio 11-15.",
      nameRequired: "Inserisci almeno una traduzione.",
    },
    i18n: {
      language: "Lingua dei testi",
      missing: "traduzione mancante",
      missingHint: "Disponibile in tedesco, manca ancora il {{lang}}.",
    },
    spots: {
      title: "Siti d’immersione",
      new: "Nuovo sito d’immersione",
      create: "Crea il sito",
      edit: "Modifica {{name}}",
      formLabel: "Modulo del sito d’immersione",
      filters: "Filtri",
      search: "Cerca",
      count_one: "{{count}} sito d’immersione",
      count_other: "{{count}} siti d’immersione",
      drafts_one: "{{count}} bozza",
      drafts_other: "{{count}} bozze",
      empty: "Nessun sito per questo filtro.",
      open: "Apri {{name}}",
      notFound: "Sito d’immersione non trovato",
      backToList: "Torna all’elenco",
      viewPublic: "Pagina pubblica",
      publish: "Pubblica",
      unpublish: "Torna a bozza",
      delete: "Elimina il sito",
      deleteTitle: "Eliminare questo sito d’immersione?",
      deleteBody: "«{{name}}» e i suoi oggetti spariscono dalla mappa. Qui non si può annullare.",
      deleteConfirm: "Elimina definitivamente",
      draftNote: "Questo sito è una bozza e non è visibile sulla mappa pubblica.",
    },
    section: {
      basics: "Dati di base",
      location: "Posizione",
      texts: "Testi",
      closed: "Periodi di chiusura",
      permanent: "Chiusura definitiva",
      ratings: "Valutazioni",
      publication: "Pubblicazione",
    },
    field: {
      name: "Nome",
      slug: "Slug (facoltativo)",
      slugDerived: "Lascia vuoto: diventa «{{slug}}».",
      slugHint: "Parte dell’indirizzo, per esempio /it/spot/…",
      waterBody: "Specchio d’acqua",
      locality: "Località",
      difficulty: "Difficoltà",
      none: "Non specificato",
      maxDepth: "Profondità massima (m)",
      status: "Stato",
      entry: "Punto d’ingresso",
      hasParking: "Indica un parcheggio",
      parking: "Parcheggio",
      lake: "Lago: {{name}}",
      noLake: "Nessun lago associato",
      hasBathy: "con dati sul fondale",
    },
    picker: {
      help: "Tocca la mappa o trascina il segnaposto. Oppure digita le coordinate.",
      lat: "Latitudine (lat)",
      lon: "Longitudine (lon)",
    },
    depth: {
      pick: "Scegli un punto per vedere la profondità.",
      ok: "Profondità da swissBATHY3D: ≈ {{depth}}",
      dry: "Questo punto è sopra il livello dell’acqua.",
      noData: "Nessun dato sul fondale in questo punto.",
      noLake: "Nessun lago con dati sul fondale in questo punto.",
      error: "Non è stato possibile leggere la profondità.",
    },
    permanent: {
      toggle: "Chiuso definitivamente",
      help: "Per i siti dove non si può più immergersi. Restano visibili e sono segnalati come chiusi.",
      since: "Dal (AAAA-MM-GG, facoltativo)",
      reason: "Motivo",
      marker: "Chiuso definitivamente",
    },
    closed: {
      help: "Si ripete ogni anno. Da e a possono scavalcare il capodanno, per esempio dal 11-15 al 02-28.",
      none: "Nessun periodo di chiusura.",
      add: "Aggiungi un periodo",
      period: "Periodo di chiusura {{n}}",
      from: "Dal (MM-GG)",
      to: "Al (MM-GG)",
      reason: "Motivo",
      remove: "Rimuovi il periodo {{n}}",
    },
    ratings: { clear: "Azzera" },
    objects: {
      title: "Oggetti",
      add: "Aggiungi oggetto",
      none: "Ancora nessun oggetto.",
      afterCreate: "Potrai aggiungere oggetti dopo aver creato il sito.",
      addTitle: "Nuovo oggetto",
      editTitle: "Modifica oggetto",
      edit: "Modifica l’oggetto {{name}}",
      delete: "Elimina l’oggetto {{name}}",
      deleteTitle: "Eliminare questo oggetto?",
      deleteBody: "«{{name}}» verrà eliminato.",
      type: "Tipo",
      name: "Nome",
      description: "Descrizione",
      location: "Posizione dell’oggetto",
      override: "Profondità misurata (m)",
      overrideHint: "Facoltativo. Lascia vuoto per usare la profondità calcolata (mostrata con ≈).",
    },
    lakes: {
      title: "Laghi",
      level: "Livello del lago",
      levelInput: "Livello del lago (m s.l.m.)",
      bathy: "con dati sul fondale",
      edit: "Cambia il livello di {{name}}",
      invalid: "Inserisci un numero tra 0 e 5000.",
      warning: "Il salvataggio ricalcola le profondità di tutti gli oggetti di questo lago.",
    },
    settings: {
      title: "Impostazioni",
      registration: "Registrazione",
      allow: "Consenti nuove registrazioni",
      max: "Max. nuovi account all'ora",
      maxHint: "0 = nessun nuovo account. Vale per tutti insieme, in ogni ora.",
      maxInvalid: "Inserisci un numero intero da 0 a 1000.",
      newLastHour: "Nuovi account (ultima ora)",
      refusedLastHour: "Registrazioni rifiutate (ultima ora)",
      noMail: "Nessun invio di e-mail configurato — la registrazione non può essere aperta",
      mailConflict: "Impossibile aprire la registrazione: nessun invio di e-mail configurato.",
      save: "Salva",
      saved: "Salvato.",
      updatedAt: "Ultima modifica: {{date}}",
    },
    model: {
      title: "Modello 3D",
      save: "Salva modello",
      none: "Nessun modello 3D caricato.",
      choose: "Scegli file",
      replace: "Sostituisci modello",
      file: "File .glb",
      drop: "Trascina qui un file .glb o sceglilo (fino a {{max}} MB).",
      chosen: "{{name}} ({{size}}), non ancora caricato",
      attribution: "Fonte / licenza",
      attributionHint:
        "Chi ha creato il modello e con quale licenza? Mostrato in modalità immersione.",
      scale: "Scala",
      heading: "Orientamento (°)",
      headingHint: "da 0 a meno di 360, direzione del lato anteriore, in senso orario dal nord.",
      discard: "Scarta la selezione",
      discardBody: "Le modifiche al modello 3D non sono ancora state salvate e andranno perse.",
      headingShort: "Orientamento",
      upload: "Carica",
      remove: "Elimina modello",
      removeTitle: "Eliminare il modello?",
      removeBody: "Il modello 3D di questo oggetto viene rimosso. L’oggetto resta.",
      uploaded: "Modello caricato.",
      saved: "Salvato.",
      deleted: "Modello eliminato.",
      size: "Dimensione",
      triangles: "triangoli",
      bounds: "Dimensioni",
      animations: "Animazioni",
      preview: "Anteprima del modello 3D",
      previewLoading: "Caricamento anteprima …",
      previewFailed: "Anteprima non disponibile.",
      north: "N",
      err: {
        extension: "Sono ammessi solo file .glb (glTF binario).",
        empty: "Il file è vuoto.",
        size: "Il file supera 8 MB.",
        magic: "Non è un file .glb valido.",
        tooLarge: "Il file è troppo grande (al massimo 8 MB).",
        forbidden: "Solo gli admin possono modificare i modelli 3D.",
        rateLimited: "Troppi caricamenti. Attendi un momento.",
        notFound: "Il modello è stato rimosso nel frattempo. Ricarica.",
        scale: "Scala tra 0,01 e 100.",
        heading: "Orientamento da 0 a meno di 360.",
      },
    },
    audit: {
      title: "Registro",
      lead: "Chi ha modificato cosa, e quando. Solo per gli admin.",
      filterEntity: "Cosa",
      filterAction: "Azione",
      all: "Tutti",
      when: "Data",
      who: "Chi",
      action: "Azione",
      what: "Cosa",
      script: "Script: {{label}}",
      deletedAccount: "Account eliminato",
      deletedTarget: "eliminato",
      unnamed: "senza nome",
      sugg: "Suggerimento",
      details: "Modifiche ({{count}})",
      more: "altro",
      less: "meno",
      empty: "Nessuna voce.",
      count_one: "{{count}} voce",
      count_other: "{{count}} voci",
      loadMore: "Carica altro",
      filterBy: "Mostra solo {{name}}",
      removeFilter: "Rimuovi filtro: {{name}}",
      chipSpot: "Sito: {{name}}",
      chipActor: "Da: {{name}}",
      unknownSpot: "Sito d'immersione",
      unknownPerson: "Persona",
      history: "Cronologia",
      yes: "sì",
      no: "no",
      adjusted: "Accettato con modifiche",
      cascaded: "Eliminato con il sito",
      redacted: "Dati personali rimossi",
      reason: "Motivo: {{text}}",
      kind: "Tipo: {{kind}}",
      accountDeleted: "Account eliminato",
      entity: {
        spot: "Sito d'immersione",
        object: "Oggetto",
        suggestion: "Suggerimento",
        sighting: "Avvistamento",
        lake: "Lago",
        user: "Utente",
        settings: "Impostazioni",
      },
      actions: {
        create: "creato",
        update: "modificato",
        delete: "eliminato",
        submit: "suggerito",
        withdraw: "ritirato",
        approve: "accettato",
        reject: "rifiutato",
      },
      field: {
        name: "Nome",
        slug: "Slug",
        location: "Posizione",
        waterBody: "Specchio d'acqua",
        locality: "Località",
        difficulty: "Difficoltà",
        maxDepthM: "Profondità massima (m)",
        closedPeriods: "Periodi di chiusura",
        permanentClosure: "Chiusura definitiva",
        status: "Stato",
        parkingLocation: "Posizione del parcheggio",
        description: "Descrizione",
        access: "Accesso",
        parking: "Parcheggio",
        entry: "Ingresso",
        hazards: "Pericoli",
        restrictions: "Restrizioni",
        facilities: "Infrastrutture",
        ratings: "Valutazioni",
        ratings_fish: "Valutazione pesci",
        ratings_walls: "Valutazione pareti",
        ratings_caves: "Valutazione grotte",
        ratings_wrecksSculptures: "Valutazione relitti e sculture",
        ratings_current: "Valutazione corrente",
        ratings_surroundings: "Valutazione dintorni",
        type: "Tipo",
        depthOverrideM: "Profondità, manuale (m)",
        model: "Modello 3D",
        model_scale: "Modello 3D: scala",
        model_headingDeg: "Modello 3D: orientamento (°)",
        model_modelId: "Modello 3D: file",
        waterLevelM: "Livello dell'acqua (m s.l.m.)",
        hasBathy: "Con dati del fondale",
        registrationOpen: "Registrazione aperta",
        maxNewAccountsPerHour: "Nuovi account all'ora (max.)",
        diveAccess: "Modalità immersione",
        banned: "Bloccato",
        role: "Ruolo",
        password: "Password",
        present: "Ancora presente",
      },
      countMore_one: "{{count}} voce più recente · altre disponibili",
      countMore_other: "{{count}} voci più recenti · altre disponibili",
      fieldLabel: "{{label}}:",
      activeFilters: "Filtri attivi",
    },
    users: {
      search: "Cerca nome o e-mail",
      filterRole: "Ruolo",
      filterStatus: "Stato",
      all: "Tutti",
      active: "Attivo",
      blocked: "Bloccato",
      new24h: "Nuovi nelle ultime 24 h",
      email: "E-mail",
      registered: "Registrato",
      lastSeen: "Ultimo accesso",
      never: "mai",
      pending: "Suggerimenti in sospeso",
      user: "Utente",
      pendingShort: "Aperti",
      diveModeShort: "incl.",
      diveMode: "Modalità immersione",
      diveModeOf: "Modalità immersione per {{name}}",
      diveModeAdmin: "Incluso con l’accesso admin",
      empty: "Nessun utente trovato.",
      count: "{{count}} utenti",
      banTitle: "Bloccare {{name}}?",
      banBody: "{{name}} viene disconnesso ovunque subito e non può più accedere.",
      unbanTitle: "Sbloccare {{name}}?",
      unbanBody: "{{name}} può di nuovo accedere.",
      title: "Utenti",
      you: "tu",
      role: "Ruolo",
      roleOf: "Ruolo di {{name}}",
      ban: "Blocca",
      unban: "Sblocca",
      banOf: "Blocca {{name}}",
      unbanOf: "Sblocca {{name}}",
      banned: "Bloccato",
      selfNote: "Il tuo ruolo e il tuo blocco non sono modificabili.",
      selfConflict: "Non è possibile per il tuo account.",
      create: "Crea utente",
      createSubmit: "Crea utente",
      created: "{{email}} è stato creato.",
      name: "Nome",
      initialPassword: "Password iniziale",
      passwordHint: "Almeno 12 caratteri. Consegnala di persona, non per e-mail o chat.",
      passwordShort: "Almeno 12 caratteri.",
      emailInvalid: "Inserisci un indirizzo e-mail valido.",
      emailTaken: "Questo indirizzo e-mail è già in uso.",
    },
  },
  three: {
    shoreLeft: "Lungo la riva, a sinistra",
    shoreRight: "Lungo la riva, a destra",
    backToEntry: "Torna all’ingresso",
    lakeEnd: "Fine del lago raggiunta",
    shoreLost: "Riva non trovata",
    spotPin: "Sito d’immersione {{name}}",
    canvas:
      "Modello 3D del fondale. Trascina per ruotare, tocca per leggere la profondità. Usa le frecce per spostare un mirino sul fondale.",
    back2d: "Vista 2D",
    radius: "Raggio",
    exaggeration: "Esagerazione",
    exaggerationValue: "{{value}}×",
    water: "Superficie dell’acqua",
    planes: "Piani di profondità",
    compassNow: "Bussola, direzione dello sguardo {{deg}} gradi {{name}}",
    cardinal: { N: "N", NE: "NE", E: "E", SE: "SE", S: "S", SW: "SO", W: "O", NW: "NO" },
    cardinalName: {
      N: "nord",
      NE: "nord-est",
      E: "est",
      SE: "sud-est",
      S: "sud",
      SW: "sud-ovest",
      W: "ovest",
      NW: "nord-ovest",
    },
    compass: "Bussola, tocca per tornare alla vista iniziale",
    loading: "Caricamento del fondale …",
    noDataHere: "Nessun dato sul fondale qui",
    rateLimited: "Troppe richieste. Riprova più tardi.",
    loadFailed: "Non è stato possibile caricare il fondale.",
    noWebgl: "Il tuo browser non può mostrare grafica 3D (WebGL).",
    contextLost: "La grafica 3D è stata interrotta.",
    reload: "Ricarica",
    legend: "Profondità",
    readoutNote: "swissBATHY3D, ±0.5 m",
    readoutNoData: "Nessun dato",
    readoutLand: "Riva",
    pinLabel: "Oggetto {{name}}, {{depth}}",
    place: {
      toggle: "Posiziona oggetto",
      hint: "Tocca il fondale per posizionare un oggetto.",
      movingHint: "Tocca il fondale: destinazione di «{{name}}».",
      cancel: "Annulla",
      move: "Sposta",
      moveConfirmTitle: "Spostare «{{name}}»?",
      moveConfirmBody:
        "«{{name}}» viene spostato nel punto toccato. La profondità viene ricalcolata.",
      moveConfirm: "Sposta",
      depthPreview: "Profondità calcolata: {{depth}} (anteprima)",
      noDepth: "Nessun dato di profondità – inserisci la profondità a mano.",
      panel: "Posiziona oggetto",
    },
    objectClose: "Chiudi i dettagli dell’oggetto",
  },
  ratings: {
    title: "Valutazioni",
    fish: "Pesci",
    walls: "Pareti",
    caves: "Grotte",
    wrecksSculptures: "Relitti e sculture",
    current: "Corrente",
    surroundings: "Dintorni",
    value: "{{label}}: {{value}} su 5",
  },
};
